import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Alert from '@mui/material/Alert'
import { formatCollision } from '../utils/activityReservations'

/**
 * Double-booking confirmation, modelled on the "Tuplavaraus" dialog in
 * ReservationModal. Conflicts are advisory everywhere else in the app; here the
 * override has to be ticked deliberately before the booking can go through.
 */
function ActivityReservationConflictDialog({ open, conflicts, onClose, onConfirm, saving }) {
  const [override, setOverride] = React.useState(false)

  React.useEffect(() => {
    if (open) setOverride(false)
  }, [open])

  const rows = conflicts || []

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Päällekkäinen varaus</DialogTitle>
      <DialogContent>
        <Alert severity='warning' sx={{ mb: 2 }}>
          {rows.length === 1
            ? 'Valittu resurssi on jo varattu tähän aikaan.'
            : rows.length + ' valittua resurssia on jo varattu tähän aikaan.'}
        </Alert>
        {rows.map((row, index) => (
          <Typography key={index} variant='body2' sx={{ mb: 1 }}>
            <b>{row.resource ? row.resource.displayName : ''}</b>
            {row.collision ? ' — ' + formatCollision(row.collision) : ''}
          </Typography>
        ))}
        <FormControlLabel
          sx={{ mt: 2 }}
          control={<Checkbox checked={override} onChange={(e) => setOverride(e.target.checked)} />}
          label='Varaa silti'
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          Peruuta
        </Button>
        <Button onClick={onConfirm} variant='contained' color='primary' disabled={!override || saving}>
          {saving ? 'Varataan...' : 'Varaa'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ActivityReservationConflictDialog
